// extracted by mini-css-extract-plugin
export default {"wrapper":"m3-z","play":"n3-z"};